module.exports = __webpack_public_path__ + "static/media/ExampleUser.1eb2757a.csv";


//////////////////
// WEBPACK FOOTER
// ./src/statics/ExampleUser.csv
// module id = 2135
// module chunks = 0